<div class="container-fluid">
  <div class="row justify-center">
    <div class="col md:col-6">
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{ 'catalog.news.title' | transloco }}</mat-card-title>
        </mat-card-header>

        <cat-news-list [items]="items"></cat-news-list>
      </mat-card>
    </div>
  </div>
</div>
